import axios from 'axios';
import {API_URL, DEBUG} from '../config';
import { notification } from 'antd';
import { t } from "@lingui/core/macro";

const service = axios.create({
    baseURL: API_URL,
    timeout: 60000
})


// NB : la session de l'Espace de gestion de compte n'est PLUS portée ici. Elle
// vit dans un cookie HttpOnly géré par le BFF Next same-origin (proxyService
// ci-dessous + pages/api/[...path].js) → cette instance globale (appels directs
// à l'API cross-origin) n'injecte aucun token compte.
// (Anciennement : Authorization: Bearer localStorage.ACCOUNT_TOKEN.)


// ── Instance PROXY (compte) ──────────────────────────────────────────────
//  TOUS les appels qui dépendent du compte connecté passent par ici → le BFF
//  same-origin pages/api/[...path].js (qui mappe /api/<X> → /v1/<X>) :
//   - les routes /account/* (via AccountAPI) — le BFF y gère le cookie ;
//   - les appels avec identité compte (paiement config.contact, soumission de
//     formulaire identity.id → garde A7), activés par ApiService(..., {useProxy}).
//  Le cookie HttpOnly part automatiquement (same-origin) et le BFF l'injecte en
//  Bearer vers l'API.
//   - baseURL relative "/api" côté navigateur ; fallback API_URL en SSR
//     (les appels compte sont client-side ; le fallback évite un crash SSR).
//   - withCredentials : envoie le cookie account_session au BFF.
//   - X-Account-Request:1 : anti-CSRF exigé par le BFF sur les mutations.
const proxyService = axios.create({
    timeout: 60000,
    withCredentials: true,
    headers: {"X-Account-Request": "1"},
})
proxyService.interceptors.request.use((config) => {
    config.baseURL = (typeof window === "undefined") ? API_URL : "/api"
    return config
}, (error) => Promise.reject(error))


// API respone interceptor (partagé par les deux instances)
function onResponse(response){ return response.data }
const NOTIFIED_STATUS = [400, 404, 500, 508]

function onError(error){
    const status = error.response?.status

    // Certains appels considèrent l'erreur comme « attendue » (ex. /account/me
    // sans session → 401/403 = « pas connecté », pas une vraie erreur). Ils
    // posent `silentError` sur la config de requête → on ne notifie pas.
    const silent = error.config?.silentError
        || !NOTIFIED_STATUS.includes(status)   // aucun message prévu → notif vide inutile (401/403…)

    if(error.response && DEBUG && typeof window !== "undefined" && !silent){
        // Les t`` sont évalués ICI et pas plus haut : au SSR la locale Lingui
        // n'est pas encore activée (cf. locales/index.js) et `i18n._` peut être
        // null → toute évaluation hors de cette garde client ferait crasher.
        let message = ''

        if (status === 404) {
            message = t`Opération serveur introuvable`
        }

        if (status === 500 || status === 400) {
            message = t`Erreur interne du serveur`
        }

        if (status === 508) {
            message = t`Gateway Timeout`
        }

        notification.error({message})
    }

    return Promise.reject(error);
}

service.interceptors.response.use(onResponse, onError)
proxyService.interceptors.response.use(onResponse, onError)

export {proxyService}
export default service
